import { INFLUENCER_SURVEY } from "./EnumConstants";
import useSurveyStore from "../../lib/Store/useSurveyStore";

const CLOUDINARY_PREFIX = "https://res.cloudinary.com/wearthat/";

const GridColsOne = " grid-cols-1 ";
const GridColsTwo = " grid-cols-2 ";
const GridColsFour = " grid-cols-2 md:grid-cols-4 ";
const GridColsFive = " grid-cols-2 xl:grid-cols-5 ";
const GridColsEight = " grid-cols-8 ";
const ColorsStyle = " w-20 h-20 rounded-full mb-4 ";

const getSizeSelectionScreen = () => {
    const surveyType = useSurveyStore?.getState()?.surveyInfo?.surveyType;
    return surveyType === INFLUENCER_SURVEY ? "screen1" : "screen4";
};

const SizeSelectionScreen = getSizeSelectionScreen();

export const ScreenJSON = {
    screen1: {
        text: "What brings you here?",
        info: "Please select one of the following options",
        questions_list: ["q1", "q37"],
        Progress: "5%",
        next_screen: "screen2",
        testVar: "1",
    },
    screen2: {
        text: "What is your skin tone?",
        info: "Select one option",
        questions_list: ["q9"],
        Progress: "10%",
        next_screen: "screen3",
    },
    screen3: {
        text: "Select your body type",
        info: "Select one option",
        questions_list: ["q10"],
        Progress: "15%",
        next_screen: "screen4",
    },
    screen4: {
        text: "Select your sizes",
        info: "Select one option",
        sizesOptions: ["US", "UK", "EU"],
        questions_list: ["q2", "q3", "q4", "q24", "q25", "q26", "q27"],
        Progress: "20%",
        next_screen: "screen5",
    },
    screen5: {
        text: "Fit Preferences",
        info: null,
        questions_list: ["h42", "q5", "q6", "h43", "q7", "q8"],
        Progress: "25%",
        next_screen: "screen6",
    },
    screen6: {
        text: "Fit Preferences",
        info: "Select one option",
        questions_list: ["q11", "q12", "q13", "q14", "q45", "q46"],
        Progress: "30%",
        next_screen: "screen7",
    },
    screen7: {
        text: "Which colours do you dislike?",
        info: null,
        questions_list: ["q15"],
        Progress: "35%",
        next_screen: "screen8",
    },
    screen8: {
        text: "Any patterns you want us to avoid?",
        info: null,
        questions_list: ["q16"],
        Progress: "40%",
        next_screen: "screen9",
    },
    screen9: {
        text: "Any other dislikes?",
        info: null,
        questions_list: ["q17", "q18"],
        Progress: "45%",
        next_screen: "screen10",
    },
    screen10: {
        text: "How much do you usually spend?",
        info: null,
        questions_list: ["q19", "q20", "q21", "q22", "q44", "q23"],
        Progress: "50%",
        next_screen: "screen11",
    },
    screen11: {
        text: "Where do you usually shop?",
        info: null,
        questions_list: ["q41"],
        Progress: "50%",
        next_screen: "screen12",
    },
    screen12: {
        text: "Style Swipe",
        info: "Tell us what you love and what you don’t!",
        styleSwipeText: "Styles You Liked",
        styleSwipeField: "q28",
        questions_list: ["q28"],
        Progress: "60%",
        next_screen: "screen13",
    },
    screen13: {
        text: "Additional Information",
        info: null,
        questions_list: ["q29", "q30", "q31"],
        Progress: "65%",
        next_screen: "screen14",
    },
    screen14: {
        text: "Additional Information",
        info: null,
        questions_list: ["q33", "q34", "q35", "q40"],
        Progress: "70%",
        next_screen: "screen15",
    },
    screen15: {
        text: "Additional Information",
        info: null,
        questions_list: ["q36", "q38"],
        Progress: "75%",
        next_screen: "screen16",
    },
    screen16: {
        text: "Your Survey Summary",
        info: null,
        Progress: "80%",
        survey_summary: [
            {
                heading: "Personal Information",
                answers: [
                    { label: "Skin Tone", field: "q9", type: "image" },
                    { label: "Height", field: "q11", type: "height" },
                    { label: "Body Type", field: "q10", type: "text" },
                    { label: "Weight", field: "q12", type: "text" },
                ],
            },
            {
                heading: "Sizing Information",
                answers: [
                    { label: "Top", field: "q2", type: "size" },
                    { label: "Bottom", field: "q4", type: "size" },
                    { label: "Jeans", field: "q24", type: "size" },
                    { label: "Dress", field: "q3", type: "size" },
                    { label: "Shoes", field: "q27", type: "size" },
                    { label: "Bra", field: ["q25", "q26"], type: "size" },
                ],
            },
            {
                heading: "Preferences",
                answers: [
                    { label: "Top Fit", field: "q5", type: "text" },
                    { label: "Bottom Fit", field: "q6", type: "text" },
                    { label: "Flaunt", field: "q7", type: "text" },
                    { label: "Downplay", field: "q8", type: "text" },
                    { label: "Curvy", field: "q13", type: "text" },
                ],
            },
            {
                heading: "Budget Preferences",
                answers: [
                    { label: "Dress", field: "q20", type: "budget" },
                    { label: "Bottom", field: "q21", type: "budget" },
                    { label: "Bags", field: "q22", type: "budget" },
                    { label: "Access.", field: "q23", type: "budget" },
                    { label: "Top", field: "q19", type: "budget" },
                    { label: "Shoes", field: "q44", type: "budget" },
                ],
            },
        ],
        questions_list: null,
        next_screen: null,
    },
};

export const QuickSurveyJSON = {
    screen1: {
        text: "Select your body type",
        info: "Select one option",
        questions_list: ["q10"],
        Progress: "14%",
        next_screen: "screen2",
    },
    screen2: {
        text: "Fit Preferences",
        info: "Select one option",
        questions_list: ["q11", "q12", "q13", "q14", "q45", "q46"],
        Progress: "28%",
        next_screen: "screen3",
    },
    screen3: {
        text: "Additional Information",
        info: null,
        questions_list: ["q29", "q30", "q31"],
        Progress: "42%",
        next_screen: "screen4",
    },

    screen4: {
        text: "Select your sizes",
        info: "Select one option",
        sizesOptions: ["US", "UK", "EU"],
        questions_list: ["q2", "q3", "q4", "q24", "q25", "q26", "q27"],
        Progress: "56%",
        next_screen: "screen5",
    },
    screen5: {
        text: `What's my box budget & outfits?`,
        info: null,
        questions_list: ["q47"],
        Progress: "70%",
        next_screen: "screen6",
    },
    screen6: {
        text: "Style Swipe",
        info: "Tell us what you love and what you don’t!",
        styleSwipeText: "Styles You Liked",
        styleSwipeField: "q28",
        questions_list: ["q28"],
        Progress: "84%",
        next_screen: "screen7",
    },
    screen7: {
        text: "Additional Information",
        info: null,
        questions_list: ["q36"],
        Progress: "98%",
        next_screen: "screen8",
    },
    screen8: {
        text: "Your Survey Summary",
        info: null,
        Progress: "100%",
        survey_summary: [
            {
                heading: "Personal Information",
                answers: [
                    { label: "Body Type", field: "q10", type: "text" },
                    { label: "Weight", field: "q12", type: "text" },
                    { label: "Height", field: "q11", type: "height" },
                    {
                        label: "Box Budget & Outfit",
                        field: "q47",
                        type: "text",
                    },
                ],
            },
            {
                heading: "Sizing Information",
                answers: [
                    { label: "Top", field: "q2", type: "size" },
                    { label: "Bottom", field: "q4", type: "size" },
                    { label: "Jeans", field: "q24", type: "size" },
                    { label: "Dress", field: "q3", type: "size" },
                    { label: "Shoes", field: "q27", type: "size" },
                    { label: "Bra", field: ["q25", "q26"], type: "size" },
                ],
            },
        ],
        questions_list: null,
        next_screen: null,
    },
};

export const QuickSurveyJSONArabic = {
    screen1: {
        text: "اختاري شكل جسمك",
        info: "اختاري خيارًا واحدًا",
        questions_list: ["q52"],
        Progress: "14%",
        next_screen: "screen2",
    },
    screen2: {
        text: "تفضيلات المقاس",
        info: "اختاري خيارًا واحدًا",
        questions_list: ["q53", "q54", "q55", "q56", "q65", "q66"],
        Progress: "28%",
        next_screen: "screen3",
    },
    screen3: {
        text: "معلومات إضافية",
        info: null,
        questions_list: ["q68", "q62", "q63"],
        Progress: "42%",
        next_screen: "screen4",
    },

    screen4: {
        text: "اختاري مقاساتكِ",
        info: "اختاري خيارًا واحدًا",
        sizesOptions: ["US", "UK", "EU"],
        questions_list: ["q49", "q50", "q51", "q57", "q58", "q59", "q60"],
        Progress: "56%",
        next_screen: "screen5",
    },
    screen5: {
        text: `ما هو ميزانيتي للصندوق والإطلالات؟`,
        info: null,
        questions_list: ["q67"],
        Progress: "70%",
        next_screen: "screen6",
    },
    screen6: {
        text: "ستايل سوايب",
        info: "أخبرينا بما يعجبكِ وما لا يعجبكِ!",
        styleSwipeText: "الستايلات التي أعجبتكِ",
        styleSwipeField: "q61",
        questions_list: ["q61"],
        Progress: "84%",
        next_screen: "screen7",
    },
    screen7: {
        text: "معلومات إضافية",
        info: null,
        questions_list: ["q64"],
        Progress: "98%",
        next_screen: "screen8",
    },
    screen8: {
        text: "ملخّص الاستبيان الخاص بكِ",
        info: null,
        Progress: "100%",
        survey_summary: [
            {
                heading: "المعلومات الشخصية",
                answers: [
                    { label: "شكل الجسم", field: "q52", type: "text" },
                    { label: "الوزن", field: "q54", type: "text" },
                    { label: "الطول", field: "q53", type: "height" },
                    {
                        label: "ميزانية الصندوق والإطلالة",
                        field: "q67",
                        type: "text",
                    },
                ],
            },
            {
                heading: "معلومات المقاسات",
                answers: [
                    { label: "الفساتين", field: "q49", type: "size" },
                    { label: "البناطيل والتنانير", field: "q51", type: "size" },
                    { label: "الجينز", field: "q57", type: "size" },
                    { label: "البلوزات", field: "q50", type: "size" },
                    { label: "الأحذية", field: "q60", type: "size" },
                    {
                        label: "حمالة الصدر",
                        field: ["q58", "q59"],
                        type: "size",
                    },
                ],
            },
        ],
        questions_list: null,
        next_screen: null,
    },
};

export const InfluencerSurveyJSON = {
    screen1: {
        text: "Select your sizes",
        info: "Select one option",
        sizesOptions: ["US", "UK", "EU"],
        questions_list: ["q2", "q3", "q4", "q24", "q25", "q26", "q27"],
        Progress: "30%",
        next_screen: "screen2",
    },
    screen2: {
        text: "Select the items you want in your boxes",
        info: "",
        questions_list: ["q48"],
        Progress: "60%",
        next_screen: "screen3",
    },
    screen3: {
        text: "Your Survey Summary",
        info: null,
        Progress: "100%",
        survey_summary: [
            {
                heading: "Sizing Information",
                answers: [
                    { label: "Top", field: "q2", type: "size" },
                    { label: "Bottom", field: "q4", type: "size" },
                    { label: "Jeans", field: "q24", type: "size" },
                    { label: "Dress", field: "q3", type: "size" },
                    { label: "Shoes", field: "q27", type: "size" },
                    { label: "Bra", field: ["q25", "q26"], type: "size" },
                ],
            },
            {
                heading: "Items in the Boxes",
                answers: [{ label: "Items", field: "q48", type: "size" }],
            },
        ],
        questions_list: null,
        next_screen: null,
    },
};

export const QuestionJSON = {
    q1: {
        text: null,
        question_type: "radio",
        gridStyle: GridColsOne,
        options: [
            {
                id: "q1_a",
                text: "I'm very busy, so I need convenience when it comes to fashion",
            },
            {
                id: "q1_b",
                text: "I need help to understand what to wear and how to put together outfits",
            },
            {
                id: "q1_c",
                text: "I'm passionate about fashion and ready to experiment with new styles and looks",
            },
        ],
        db_column: "landing_reason",
    },
    q2: {
        text: "Tops",
        question_type: "radioSize",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                    "26",
                    "28",
                ],
            },
            {
                title: "US",
                values: [
                    "0",
                    "2",
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                ],
            },
            {
                title: "EU",
                values: [
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                    "50",
                    "52",
                    "54",
                    "56",
                ],
            },
        ],
        db_column: "size_tops",
    },

    q3: {
        text: "Dresses",
        question_type: "radioSize",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                    "26",
                    "28",
                ],
            },
            {
                title: "US",
                values: [
                    "0",
                    "2",
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                ],
            },
            {
                title: "EU",
                values: [
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                    "50",
                    "52",
                    "54",
                    "56",
                ],
            },
        ],
        db_column: "size_dresses",
    },

    q4: {
        text: "Bottoms",
        question_type: "radioSize",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                    "26",
                    "28",
                ],
            },
            {
                title: "US",
                values: [
                    "0",
                    "2",
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                ],
            },
            {
                title: "EU",
                values: [
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                    "50",
                    "52",
                    "54",
                    "56",
                ],
            },
        ],
        db_column: "size_bottoms",
    },

    q5: {
        text: "How do you prefer your clothes to fit on the top?",
        question_type: "radio",
        gridStyle: GridColsFive,
        options: [
            {
                id: "q5_a",
                text: "Oversized",
            },
            {
                id: "q5_b",
                text: "Loose",
            },
            {
                id: "q5_c",
                text: "Fitted",
            },
            {
                id: "q5_d",
                text: "Straight",
            },
            {
                id: "q5_e",
                text: "Tight",
            },
        ],
        db_column: "preference_top",
    },
    q6: {
        text: "How do you prefer your clothes to fit on the bottom?",
        question_type: "radio",
        gridStyle: GridColsFive,
        options: [
            {
                id: "q4_a",
                text: "Oversized",
            },
            {
                id: "q4_b",
                text: "Loose",
            },
            {
                id: "q4_c",
                text: "Fitted",
            },
            {
                id: "q4_d",
                text: "Straight",
            },
            {
                id: "q4_e",
                text: "Tight",
            },
        ],
        db_column: "preference_bottom",
    },
    q7: {
        text: "Which features do you want to flaunt?",
        question_type: "checkbox",
        gridStyle: GridColsFive,
        options: [
            {
                id: "q7_a",
                text: "Midsection",
            },
            {
                id: "q7_b",
                text: "Cleavage",
            },
            {
                id: "q7_c",
                text: "Back",
            },
            {
                id: "q7_d",
                text: "Legs",
            },
            {
                id: "q7_e",
                text: "Rear",
            },
        ],
        db_column: "preference_flaunt",
    },
    q8: {
        text: "What features do you want to downplay?",
        question_type: "checkbox",
        gridStyle: GridColsFive,
        options: [
            {
                id: "q8_a",
                text: "Midsection",
            },
            {
                id: "q8_b",
                text: "Cleavage",
            },
            {
                id: "q8_c",
                text: "Back",
            },
            {
                id: "q8_d",
                text: "Legs",
            },
            {
                id: "q8_e",
                text: "Rear",
            },
        ],
        db_column: "preference_downplay",
    },
    q9: {
        text: null,
        question_type: "skinTone",
        gridStyle: GridColsFour,
        options: [
            {
                id: "q9_a",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951683/customers/io4z44wqfau5z2krvbo1.jpg",
                text: "",
                name: "Pale",
            },
            {
                id: "q9_b",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951717/customers/ev1mxj9wqwshq9h4k4bh.jpg",
                text: "",
                name: "Pink",
            },
            {
                id: "q9_c",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951740/customers/ydv6wcqvfqkqpxogwmrj.jpg",
                text: "",
                name: "Fair",
            },
            {
                id: "q9_d",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951757/customers/lpwentgc2oymf8jjd5kv.jpg",
                text: "",
                name: "Olive",
            },
            {
                id: "q9_d",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951783/customers/kibwjioqkgwcnzoiqnf5.jpg",
                text: "",
                name: "Tan",
            },
            {
                id: "q9_d",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951795/customers/x4lzjagzdirtjrv6ny8y.jpg",
                text: "",
                name: "Brown",
            },
            {
                id: "q9_d",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951813/customers/zhltlkzrrxspkt1thypq.jpg",
                text: "",
                name: "Deep",
            },
            {
                id: "q9_d",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719951819/customers/udqkyjrv2rocfuntorj6.jpg",
                text: "",
                name: "Dark",
            },
        ],
        db_column: "skin_tone",
    },
    q10: {
        text: null,
        question_type: "bodyType",
        gridStyle: GridColsFour,
        options: [
            {
                id: "q10_a",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560030/customers/xrsfzngzdgtav3ce5jbp.svg",
                text: "Hourglass",
                value: "Hourglass",
            },

            {
                id: "q10_b",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560491/customers/afdbqeqm863lldvgilnj.svg",
                text: "Rectangle",
                value: "Rectangle",
            },

            {
                id: "q10_c",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560479/customers/tnmy1q6l4gx70xwspz9j.svg",
                text: "Apple",
                value: "Apple",
            },

            {
                id: "q10_d",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560501/customers/i3cxdyhctdlawerfyc3i.svg",
                text: "Pear",
                value: "Pear",
            },

            {
                id: "q10_e",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560457/customers/evakzwq0g1v5knvz0mpg.svg",
                text: "Inverted Triangle",
                value: "Inverted Triangle",
            },
        ],
        db_column: "body_type",
    },

    q11: {
        text: "How tall are you?",
        question_type: "unitInput",
        measurement_units: [
            { id: "cm", label: "CM" },
            { id: "ft", label: "FT/IN" },
        ],
        options: [],
        db_column: "preference_height",
    },

    q12: {
        text: "What is your weight?",
        info: "If you’re uncomfortable, feel free to skip this.",
        question_type: "unitInput",
        measurement_units: [
            { id: "lb", label: "LB" },
            { id: "kg", label: "KG" },
        ],
        options: [],
        db_column: "preference_weight",
    },

    q13: {
        text: "Are you curvy?",
        question_type: "radio",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q13_a",
                text: "Yes",
            },
            {
                id: "q13_b",
                text: "No",
            },
        ],
        db_column: "preference_curvy",
    },

    q14: {
        text: "Are you expecting?",
        question_type: "radio",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q14_a",
                text: "Yes",
            },
            {
                id: "q14_b",
                text: "No",
            },
        ],
        db_column: "preference_expecting",
    },

    q15: {
        text: null,
        question_type: "checkbox",
        gridStyle: GridColsFour,
        colorStyle: ColorsStyle,
        dislike: true,
        options: [
            {
                id: "q15_b",
                text: "Black",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050989/colors%20and%20patterns/ihecq4zzkwcryrwf0zby.svg",
            },
            {
                id: "q15_n",
                text: "Silver",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050981/colors%20and%20patterns/efog7e5pa4ukg5p7w57l.svg",
            },
            {
                id: "q15_h",
                text: "Grey.",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050981/colors%20and%20patterns/yt7yg4rfhuxsfe2cuymp.svg",
            },
            {
                id: "q15_p",
                text: "White",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050982/colors%20and%20patterns/u7xobzeinlhxq6jrckcl.svg",
            },
            {
                id: "q15_d",
                text: "Brown",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050981/colors%20and%20patterns/dxbzmrcdprz5irt2hwjk.svg",
            },
            {
                id: "q15_f",
                text: "Golden",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050983/colors%20and%20patterns/xwroavoirigpytmanydz.svg",
            },
            {
                id: "q15_j",
                text: "Orange",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050980/colors%20and%20patterns/d5wc5wbblgilngkdlpc5.svg",
            },
            {
                id: "q15_a",
                text: "Beige",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050987/colors%20and%20patterns/nbcmg41bpqmiqdqkutof.svg",
            },
            {
                id: "q15_e",
                text: "Burgundy",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050987/colors%20and%20patterns/ara6oo51jssmvzql6lqm.svg",
            },
            {
                id: "q15_m",
                text: "Red",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050982/colors%20and%20patterns/dbl0nwbwyffnmumvsyuk.svg",
            },
            {
                id: "q15_l",
                text: "Purple",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050982/colors%20and%20patterns/hnpkchil9d31rffxqg8x.svg",
            },
            {
                id: "q15_k",
                text: "Pink",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050989/colors%20and%20patterns/askq2yk5k7kdl35nsmpy.svg",
            },
            {
                id: "q15_i",
                text: "Navy",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050981/colors%20and%20patterns/dwxrkebkjwbghj6l0naz.svg",
            },

            {
                id: "q15_c",
                text: "Blue",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050988/colors%20and%20patterns/wu5mjupwtjxkwy4sddos.svg",
            },
            {
                id: "q15_g",
                text: "Green",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050980/colors%20and%20patterns/nq4koq3f3a6vochpv822.svg",
            },
            {
                id: "q15_o",
                text: "Teal",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721050986/colors%20and%20patterns/nepipq6j5cqeh1uezybw.svg",
            },
        ],
        db_column: "preference_dislike_colors",
    },
    q16: {
        text: null,
        question_type: "checkbox",
        gridStyle: GridColsFour,
        colorStyle: ColorsStyle,
        dislike: true,
        options: [
            {
                id: "q16_a",
                name: "Animal",
                text: "Animal",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051015/colors%20and%20patterns/mz1lqs2rprh1ubqhwxxt.svg",
            },
            {
                id: "q16_b",
                name: "Floral",
                text: "Floral",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051017/colors%20and%20patterns/ta0kvctfsrkfwgcgjlgf.svg",
            },
            {
                id: "q16_c",
                name: "Gingham",
                text: "Gingham",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051016/colors%20and%20patterns/dwaxlptqgliz5ymyc87z.svg",
            },
            {
                id: "q16_d",
                name: "Houndsooth",
                text: "Houndsooth",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051018/colors%20and%20patterns/yl3b1m96avwkxvsvs5r2.svg",
            },
            {
                id: "q16_e",
                name: "Paisley",
                text: "Paisley",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051019/colors%20and%20patterns/tnqqowg0xhikxj5drxrz.svg",
            },
            {
                id: "q16_f",
                name: "Polka Dots",
                text: "Polka Dots",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051017/colors%20and%20patterns/dqg0ybcasq7f8qvleswp.svg",
            },
            {
                id: "q16_g",
                name: "Plaid",
                text: "Plaid",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051029/colors%20and%20patterns/g55elsen7pfcpor2gibr.svg",
            },
            {
                id: "q16_h",
                name: "Stripes",
                text: "Stripes",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1721051088/colors%20and%20patterns/ysw7eweo5etw5nr4dfjc.svg",
            },
        ],
        db_column: "preference_dislike_patterns",
    },
    q17: {
        text: "Any fabric would you want us to avoid?",
        question_type: "checkbox",
        gridStyle: GridColsFour,
        dislike: true,
        options: [
            {
                id: "q17_a",
                text: "Wool",
            },
            {
                id: "q17_b",
                text: "Polyester",
            },
            {
                id: "q17_c",
                text: "Faux Leather",
            },
            {
                id: "q17_d",
                text: "Leather",
            },
            {
                id: "q17_e",
                text: "Faux Fur",
            },
        ],
        db_column: "preference_dislike_fabric",
    },
    q18: {
        text: "Is there anything you would never want to receive?",
        question_type: "checkbox",
        gridStyle: GridColsFour,
        dislike: true,
        options: [
            {
                id: "q17_a",
                text: "Jackets",
            },
            {
                id: "q17_b",
                text: "Shoes",
            },
            {
                id: "q17_c",
                text: "Jewellery",
            },
            {
                id: "q17_d",
                text: "Bags",
            },
            {
                id: "q17_e",
                text: "Skirts",
            },
            {
                id: "q17_f",
                text: "Dresses",
            },
            {
                id: "q17_g",
                text: "Shorts",
            },
            {
                id: "q17_h",
                text: "Jeans",
            },
            {
                id: "q17_i",
                text: "Pants",
            },
            {
                id: "q17_j",
                text: "Tops",
            },
        ],
        db_column: "preference_dislike_items",
    },
    q19: {
        text: "Tops",
        question_type: "budget",
        min: {
            AED: 300,
            SAR: 300,
            AUD: 50,
            GBP: 50,
            EUR: 50,
            USD: 50,
        },
        max: { AED: 1000, SAR: 1000, AUD: 200, GBP: 200, EUR: 200, USD: 200 },
        step: { AED: 100, SAR: 100, AUD: 10, GBP: 10, EUR: 10, USD: 10 },
        values: {
            AED: [400, 600],
            SAR: [400, 600],
            AUD: [70, 110],
            GBP: [70, 110],
            EUR: [70, 110],
            USD: [70, 110],
        },
        db_column: "budget_tops",
    },
    q20: {
        text: "Dresses",
        question_type: "budget",
        min: {
            AED: 300,
            SAR: 300,
            AUD: 50,
            GBP: 50,
            EUR: 50,
            USD: 50,
        },
        max: { AED: 1000, SAR: 1000, AUD: 200, GBP: 200, EUR: 200, USD: 200 },
        step: { AED: 100, SAR: 100, AUD: 10, GBP: 10, EUR: 10, USD: 10 },
        values: {
            AED: [400, 600],
            SAR: [400, 600],
            AUD: [70, 110],
            GBP: [70, 110],
            EUR: [70, 110],
            USD: [70, 110],
        },
        db_column: "budget_dresses",
    },
    q21: {
        text: "Bottoms",
        question_type: "budget",
        min: {
            AED: 300,
            SAR: 300,
            AUD: 50,
            GBP: 50,
            EUR: 50,
            USD: 50,
        },
        max: { AED: 1000, SAR: 1000, AUD: 200, GBP: 200, EUR: 200, USD: 200 },
        step: { AED: 100, SAR: 100, AUD: 10, GBP: 10, EUR: 10, USD: 10 },
        values: {
            AED: [400, 600],
            SAR: [400, 600],
            AUD: [70, 110],
            GBP: [70, 110],
            EUR: [70, 110],
            USD: [70, 110],
        },
        db_column: "budget_bottoms",
    },
    q22: {
        text: "Bags",
        question_type: "budget",
        min: {
            AED: 300,
            SAR: 300,
            AUD: 50,
            GBP: 50,
            EUR: 50,
            USD: 50,
        },
        max: { AED: 1000, SAR: 1000, AUD: 200, GBP: 200, EUR: 200, USD: 200 },
        step: { AED: 100, SAR: 100, AUD: 10, GBP: 10, EUR: 10, USD: 10 },
        values: {
            AED: [400, 600],
            SAR: [400, 600],
            AUD: [70, 110],
            GBP: [70, 110],
            EUR: [70, 110],
            USD: [70, 110],
        },
        db_column: "budget_bags",
    },
    q23: {
        text: "Accessories",
        question_type: "budget",
        min: {
            AED: 300,
            SAR: 300,
            AUD: 50,
            GBP: 50,
            EUR: 50,
            USD: 50,
        },
        max: { AED: 1000, SAR: 1000, AUD: 200, GBP: 200, EUR: 200, USD: 200 },
        step: { AED: 100, SAR: 100, AUD: 10, GBP: 10, EUR: 10, USD: 10 },
        values: {
            AED: [400, 600],
            SAR: [400, 600],
            AUD: [70, 110],
            GBP: [70, 110],
            EUR: [70, 110],
            USD: [70, 110],
        },
        db_column: "budget_accessories",
    },
    q24: {
        text: "Jeans",
        question_type: "radioSize",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                ],
            },
            {
                title: "US",
                values: [
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                ],
            },
            {
                title: "EU",
                values: [
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                ],
            },
        ],
        db_column: "size_jeans",
    },

    q25: {
        text: "Bra",
        question_type: "radioSize",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "28",
                    "30",
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                ],
            },
            {
                title: "US",
                values: [
                    "28",
                    "30",
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                ],
            },
            {
                title: "EU",
                values: [
                    "28",
                    "30",
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                ],
            },
        ],
        db_column: "size_bra",
    },

    q26: {
        text: "Cup Size",
        question_type: "radioSize",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "AA",
                    "A",
                    "B",
                    "C",
                    "D",
                    "DD",
                    "E",
                    "F",
                    "FF",
                    "G",
                    "GG",
                    "H",
                    "HH",
                ],
            },
            {
                title: "US",
                values: [
                    "AA",
                    "A",
                    "B",
                    "C",
                    "D",
                    "DD",
                    "E",
                    "F",
                    "FF",
                    "G",
                    "GG",
                    "H",
                    "HH",
                ],
            },
            {
                title: "EU",
                values: [
                    "AA",
                    "A",
                    "B",
                    "C",
                    "D",
                    "DD",
                    "E",
                    "F",
                    "FF",
                    "G",
                    "GG",
                    "H",
                    "HH",
                ],
            },
        ],
        db_column: "size_cup",
    },

    q27: {
        text: "Shoes",
        question_type: "radioSize",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "3",
                    "3.5",
                    "4",
                    "4.5",
                    "5",
                    "5.5",
                    "6",
                    "6.5",
                    "7",
                    "7.5",
                    "8",
                ],
            },
            {
                title: "US",
                values: [
                    "5",
                    "5.5",
                    "6",
                    "6.5",
                    "7",
                    "7.5",
                    "8",
                    "8.5",
                    "9",
                    "9.5",
                    "10",
                ],
            },
            {
                title: "EU",
                values: [
                    "35.5",
                    "36",
                    "37",
                    "37.5",
                    "38",
                    "39",
                    "39.5",
                    "40",
                    "40.5",
                    "41",
                    "42",
                ],
            },
        ],
        db_column: "size_shoes",
    },

    q28: {
        text: "Styles You Liked",
        question_type: "swipe",
        options: [
            {
                id: "style_swipe_image_0",
                image: {
                    desktop:
                        "https://res.cloudinary.com/wearthat/image/upload/v1720466114/customers/do7ayopshskw1dv3ciyq.svg",
                    mobile: "https://res.cloudinary.com/wearthat/image/upload/v1720466262/customers/c1gxvgh1biohh4vqntul.svg",
                },
            },
            {
                id: "style_swipe_image_1",
                personality: "effortless_visionary",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621288/froy6qwhd8clmkazd3xb.svg",
            },
            {
                id: "style_swipe_image_2",
                personality: "graceful_dreamer",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621189/wodlox0mptkl3hg0arwc.svg",
            },
            {
                id: "style_swipe_image_3",
                personality: "free_spirit",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621024/loeynokwvwoeqmfqmhcx.svg",
            },
            {
                id: "style_swipe_image_4",
                personality: "powerful_presence",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621439/otaqd3h5d3w4cmpiv9ey.svg",
            },
            {
                id: "style_swipe_image_5",
                personality: "effortless_visionary",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622523/aspyun4hbsooyglsosfx.svg",
            },
            {
                id: "style_swipe_image_6",
                personality: "graceful_dreamer",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622381/asjbek1ad85sdtonwbyo.svg",
            },
            {
                id: "style_swipe_image_7",
                personality: "free_spirit",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683620211/oyo63lquad3htnjoalf3.svg",
            },
            {
                id: "style_swipe_image_8",
                personality: "powerful_presence",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622267/upv001vxnlmr00icvc4q.svg",
            },
            {
                id: "style_swipe_image_9",
                personality: "effortless_visionary",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622418/p79dz9tybipnswmefzgb.svg",
            },
            {
                id: "style_swipe_image_10",
                personality: "graceful_dreamer",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621124/kxxg0s9q166vk3hx1k7r.svg",
            },
            {
                id: "style_swipe_image_11",
                personality: "free_spirit",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621063/fdqomjmjadpy28loqhaj.svg",
            },
            {
                id: "style_swipe_image_12",
                personality: "powerful_presence",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621780/jwe7l6hp5rglgukvngna.svg",
            },
            {
                id: "style_swipe_image_13",
                personality: "effortless_visionary",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622454/pd7bngebh2xazhbk7fcl.svg",
            },
            {
                id: "style_swipe_image_14",
                personality: "graceful_dreamer",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621523/ma7liuauvzaixbpuucrg.svg",
            },
            {
                id: "style_swipe_image_15",
                personality: "free_spirit",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621094/c8wov5im4veugmrpbtts.svg",
            },
            {
                id: "style_swipe_image_16",
                personality: "powerful_presence",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621817/hkznj1eynfgfbeycp70v.svg",
            },
            {
                id: "style_swipe_image_17",
                personality: "effortless_visionary",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621666/bthsavmfqvsbirqlfngk.svg",
            },
            {
                id: "style_swipe_image_18",
                personality: "graceful_dreamer",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621485/gyiw8wzyz3i6gngfvadd.svg",
            },
            {
                id: "style_swipe_image_19",
                personality: "free_spirit",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621739/qj1ylnmde7eebotud04b.svg",
            },
            {
                id: "style_swipe_image_20",
                personality: "powerful_presence",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622198/x8hzzosj8rsgulas4kxv.svg",
            },
            {
                id: "style_swipe_image_21",
                personality: "effortless_visionary",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622305/moghf9yv0ldpxxlwiweu.svg",
            },
        ],
        db_column: "style_swipe",
    },

    q29: {
        text: null,
        question_type: "datePicker",
        label: "",
        options: [],
        db_column: "dob",
    },

    q30: {
        text: "Nationality*",
        question_type: "select",
        options: [
            "Afghan",
            "Albanian",
            "Algerian",
            "American",
            "Andorran",
            "Angolan",
            "Antiguan",
            "Argentine",
            "Armenian",
            "Australian",
            "Austrian",
            "Azerbaijani",
            "Bahamian",
            "Bahraini",
            "Bangladeshi",
            "Barbadian",
            "Belarusian",
            "Belgian",
            "Belizean",
            "Beninese",
            "Bhutanese",
            "Bolivian",
            "Bosnian",
            "Botswanan",
            "Brazilian",
            "British",
            "Bruneian",
            "Bulgarian",
            "Burkinabe",
            "Burmese",
            "Burundian",
            "Cambodian",
            "Cameroonian",
            "Canadian",
            "Cape Verdean",
            "Central African",
            "Chadian",
            "Chilean",
            "Chinese",
            "Colombian",
            "Comoran",
            "Congolese (Congo-Brazzaville)",
            "Congolese (Congo-Kinshasa)",
            "Costa Rican",
            "Croatian",
            "Cuban",
            "Cypriot",
            "Czech",
            "Danish",
            "Djiboutian",
            "Dominican",
            "Dominican (Dominican Republic)",
            "Dutch",
            "East Timorese",
            "Ecuadorian",
            "Egyptian",
            "Emirati",
            "Equatorial Guinean",
            "Eritrean",
            "Estonian",
            "Eswatini",
            "Ethiopian",
            "Fijian",
            "Filipino",
            "Finnish",
            "French",
            "Gabonese",
            "Gambian",
            "Georgian",
            "German",
            "Ghanaian",
            "Greek",
            "Grenadian",
            "Guatemalan",
            "Guinean",
            "Guinean (Guinea-Bissau)",
            "Guyanese",
            "Haitian",
            "Honduran",
            "Hungarian",
            "Icelandic",
            "Indian",
            "Indonesian",
            "Iranian",
            "Iraqi",
            "Irish",
            "Israeli",
            "Italian",
            "Ivorian",
            "Jamaican",
            "Japanese",
            "Jordanian",
            "Kazakh",
            "Kenyan",
            "Kiribati",
            "Korean (North)",
            "Korean (South)",
            "Kosovar",
            "Kuwaiti",
            "Kyrgyz",
            "Lao",
            "Latvian",
            "Lebanese",
            "Liberian",
            "Libyan",
            "Liechtensteiner",
            "Lithuanian",
            "Luxembourger",
            "Madagascan",
            "Malawian",
            "Malaysian",
            "Maldivian",
            "Malian",
            "Maltese",
            "Marshallese",
            "Mauritanian",
            "Mauritian",
            "Mexican",
            "Micronesian",
            "Moldovan",
            "Monacan",
            "Mongolian",
            "Montenegrin",
            "Moroccan",
            "Mozambican",
            "Namibian",
            "Nauruan",
            "Nepalese",
            "New Zealander",
            "Nicaraguan",
            "Nigerian",
            "Nigerien",
            "Niuean",
            "North Macedonian",
            "Norwegian",
            "Omani",
            "Pakistani",
            "Palauan",
            "Palestinian",
            "Panamanian",
            "Papua New Guinean",
            "Paraguayan",
            "Peruvian",
            "Polish",
            "Portuguese",
            "Qatari",
            "Romanian",
            "Russian",
            "Rwandan",
            "Saint Kitts and Nevis",
            "Saint Lucian",
            "Saint Vincentian",
            "Salvadoran",
            "Samoan",
            "San Marinese",
            "Sao Tomean",
            "Saudi Arabian",
            "Senegalese",
            "Serbian",
            "Seychellois",
            "Sierra Leonean",
            "Singaporean",
            "Slovak",
            "Slovenian",
            "Solomon Islander",
            "Somali",
            "South African",
            "South Sudanese",
            "Spanish",
            "Sri Lankan",
            "Sudanese",
            "Surinamese",
            "Swedish",
            "Swiss",
            "Syrian",
            "Tajik",
            "Tanzanian",
            "Thai",
            "Tongan",
            "Trinidadian/Tobagonian",
            "Tunisian",
            "Turkish",
            "Turkmen",
            "Tuvaluan",
            "Ugandan",
            "Ukrainian",
            "Uruguayan",
            "Uzbek",
            "Vanuatuan",
            "Venezuelan",
            "Vietnamese",
            "Yemeni",
            "Zambian",
            "Zimbabwean",
        ],
        db_column: "nationality",
    },

    q31: {
        text: "What do you do for a living?",
        question_type: "select",
        options: [
            "Production / Manufacturing",
            "Personal Care & Service",
            "Office / Administration",
            "Military / Protective Service",
            "Media / Communications",
            "Management",
            "Hospitality / Food Service",
            "Health Practitioner / Technician",
            "Financial Services",
            "Farming / Fishing / Forestry",
            "Entertainer / Performer",
            "Computer / IT",
            "Community / Social Service",
            "Business / Client Service",
            "Building / Maintenance",
            "Art / Design",
            "Architecture / Engineering",
            "Education",
            "Legal",
            "Student",
            "Stay-At-Home Parent",
            "Self-Employed",
            "Transportation",
            "Technology",
            "Science",
            "Sales",
            "Retail",
            "Retired",
            "Not Employed",
            "Other",
        ],
        db_column: "occupation",
    },

    q32: {
        text: "How did you hear about us?",
        question_type: "select",
        options: ["Friends", "Google Search", "Instagram", "Facebook"],
        db_column: "hear_about_us",
    },
    q33: {
        text: "",
        question_type: "input",
        label: "Instagram Profile Link",
        db_column: "instagram_link",
    },
    q34: {
        text: "",
        question_type: "input",
        label: "LinkedIn Profile Link",
        db_column: "linkedin_link",
    },
    q35: {
        text: "",
        question_type: "input",
        label: "Pinterest Profile Link",
        db_column: "pinterest_link",
    },
    q36: {
        text: "Which occasion(s) shall we focus on for your first box?",
        selectionInfo: "(Choose any two)",
        question_type: "checkbox",
        gridStyle: GridColsTwo,
        maxLimit: 2,
        options: [
            {
                id: "q1_a",
                text: "Holiday / Event",
                next_question: null,
            },
            {
                id: "q1_b",
                text: "Going Out",
                next_question: null,
            },
            {
                id: "q1_c",
                text: "Work",
                next_question: null,
            },
            {
                id: "q1_d",
                text: "Wardrobe Essentials",
                next_question: null,
            },
            {
                id: "q1_e",
                text: "Day to Day",
                next_question: null,
            },
        ],
        db_column: "firstbox_occasions_focus",
    },

    q37: {
        text: "Any other reasons?",
        question_type: "textArea",
        db_column: "style_therapist",
        maxCharacterLength: 500,
    },
    q38: {
        text: "Tell your stylist about any requests for your box:",
        question_type: "textArea",
        db_column: "box_request",
        maxCharacterLength: 500,
    },
    q39: {
        text: "",
        question_type: "checkbox",
        gridStyle: GridColsFour,
        options: [
            {
                id: "q17_a",
                text: "Wool",
            },
            {
                id: "q17_b",
                text: "Polyester",
            },
            {
                id: "q17_c",
                text: "Faux Leather",
            },
            {
                id: "q17_d",
                text: "Leather",
            },
            {
                id: "q17_e",
                text: "Faux Fur",
            },
        ],
        db_column: "preference_dislike_fabric",
    },
    q40: {
        text: "",
        question_type: "imageUploader",
        options: [],
        db_column: "upload_photos",
    },
    q41: {
        text: null,
        question_type: "checkbox",
        gridStyle: GridColsFour,
        colorStyle: ColorsStyle,
        options: [
            {
                id: "q15_a",
                name: "Banana Republic",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932399/customers/wr6e1swnxg2gejpramli.svg",
            },
            {
                id: "q15_b",
                name: "Bloomingdale's",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932408/customers/loinar2enn04p1bfpf9w.svg",
            },
            {
                id: "q15_c",
                name: "Farfetch",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932413/customers/hsdpqm5qppeoctryasbj.svg",
            },
            {
                id: "q15_d",
                name: "Harvey Nichols",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932415/customers/wkdp64xfnvfoter9oltg.svg",
            },
            {
                id: "q15_e",
                name: "H&M",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932419/customers/rhvdk6y3r4ct6ivlketz.svg",
            },
            {
                id: "q15_e",
                name: "Massimo Dutti",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932422/customers/auvqnj86ubu8s36tooul.svg",
            },
            {
                id: "q15_e",
                name: "Namshii",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932426/customers/djiipv69wjqssxmrnb3t.svg",
            },
            {
                id: "q15_e",
                name: "Revolve",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719936039/customers/nr6y3fmiu7zartxc19sq.svg",
            },
            {
                id: "q15_e",
                name: "Net-a-porter",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932429/customers/vw0ewcidspupp6f5kkzz.svg",
            },
            {
                id: "q15_e",
                name: "Ounass",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932432/customers/q0ag35vohun6cbmekz5e.svg",
            },
            {
                id: "q15_e",
                name: "Shopbop",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932895/customers/jbx66ijroztvytlqpntz.svg",
            },
            {
                id: "q15_e",
                name: "Zara",
                text: null,
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719932897/customers/hyg8agxjckmzvkstgtcb.svg",
            },
        ],
        db_column: "preference_brands",
    },
    h42: {
        text: "Preferred Fit ",
        info: "(Choose one option)",
        question_type: "questionHeading",
    },
    h43: {
        text: "Preferred Style ",
        info: "(Choose one or more options)",
        question_type: "questionHeading",
    },
    q44: {
        text: "Shoes",
        question_type: "budget",
        min: {
            AED: 300,
            SAR: 300,
            AUD: 50,
            GBP: 50,
            EUR: 50,
            USD: 50,
        },
        max: { AED: 1000, SAR: 1000, AUD: 200, GBP: 200, EUR: 200, USD: 200 },
        step: { AED: 100, SAR: 100, AUD: 10, GBP: 10, EUR: 10, USD: 10 },
        values: {
            AED: [400, 600],
            SAR: [400, 600],
            AUD: [70, 110],
            GBP: [70, 110],
            EUR: [70, 110],
            USD: [70, 110],
        },
        db_column: "budget_shoes",
    },
    q45: {
        text: "Do you dress modestly?",
        question_type: "radio",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q45_a",
                text: "Yes",
            },
            {
                id: "q45_b",
                text: "No",
            },
        ],
        db_column: "preference_modestly",
    },

    q46: {
        text: "Are you hijabi?",
        question_type: "animated_radio",
        depend_question: "q45",
        depend_answer: "Yes",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q46_a",
                text: "Yes",
            },
            {
                id: "q46_b",
                text: "No",
            },
        ],
        db_column: "preference_hijabi",
    },

    q47: {
        text: null,
        question_type: "radio",
        gridStyle: GridColsOne,
        options: [
            {
                id: "q47_a",
                text: "1-3k AED Up to 4 looks",
            },
            {
                id: "q47_b",
                text: "3-5k AED 5-8 looks",
            },
            {
                id: "q47_c",
                text: "5k+ AED 8+ looks",
            },
        ],

        db_column: "box_budget_outfit",
    },

    q48: {
        text: null,
        question_type: "dress_select",
        gridStyle: GridColsTwo,
        db_column: "ecomm_products",
    },
    q49: {
        text: "الفساتين",
        question_type: "radioSize-arabic",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                    "26",
                    "28",
                ],
            },
            {
                title: "US",
                values: [
                    "0",
                    "2",
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                ],
            },
            {
                title: "EU",
                values: [
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                    "50",
                    "52",
                    "54",
                    "56",
                ],
            },
        ],
        db_column: "size_tops",
    },
    q50: {
        text: "البلوزات",
        question_type: "radioSize-arabic",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                    "26",
                    "28",
                ],
            },
            {
                title: "US",
                values: [
                    "0",
                    "2",
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                ],
            },
            {
                title: "EU",
                values: [
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                    "50",
                    "52",
                    "54",
                    "56",
                ],
            },
        ],
        db_column: "size_dresses",
    },
    q51: {
        text: "البناطيل والتنانير",
        question_type: "radioSize-arabic",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                    "26",
                    "28",
                ],
            },
            {
                title: "US",
                values: [
                    "0",
                    "2",
                    "4",
                    "6",
                    "8",
                    "10",
                    "12",
                    "14",
                    "16",
                    "18",
                    "20",
                    "22",
                    "24",
                ],
            },
            {
                title: "EU",
                values: [
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                    "50",
                    "52",
                    "54",
                    "56",
                ],
            },
        ],
        db_column: "size_bottoms",
    },
    q52: {
        text: null,
        question_type: "bodyType",
        gridStyle: GridColsFour,
        options: [
            {
                id: "q10_a",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560030/customers/xrsfzngzdgtav3ce5jbp.svg",
                text: "ساعة رملية",
                value: "Hourglass",
            },
            {
                id: "q10_b",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560491/customers/afdbqeqm863lldvgilnj.svg",
                text: "مستطيل",
                value: "Rectangle",
            },
            {
                id: "q10_c",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560479/customers/tnmy1q6l4gx70xwspz9j.svg",
                text: "تفاحة",
                value: "Apple",
            },
            {
                id: "q10_d",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560501/customers/i3cxdyhctdlawerfyc3i.svg",
                text: "كمثرى",
                value: "Pear",
            },
            {
                id: "q10_e",
                image: "https://res.cloudinary.com/wearthat/image/upload/v1719560457/customers/evakzwq0g1v5knvz0mpg.svg",
                text: "مثلث",
                value: "Inverted Triangle",
            },
        ],
        db_column: "body_type",
    },
    q53: {
        text: "ما هو طولك؟",
        question_type: "unitInput-arabic",
        measurement_units: [
            { id: "cm", label: "CM" },
            { id: "ft", label: "FT/IN" },
        ],
        options: [],
        db_column: "preference_height",
    },
    q54: {
        text: "ما هو وزنك؟",
        info: "إذا شعرتِ بعدم الارتياح، يمكنكِ تخطي هذه الخطوة",
        question_type: "unitInput-arabic",
        measurement_units: [
            { id: "lb", label: "LB" },
            { id: "kg", label: "KG" },
        ],
        options: [],
        db_column: "preference_weight",
    },
    q55: {
        text: "هل تتمتعين بمنحنيات؟",
        question_type: "radio-arabic",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q13_a",
                text: "نعم",
                value: "Yes",
            },
            {
                id: "q13_b",
                text: "لا",
                value: "No",
            },
        ],
        db_column: "preference_curvy",
    },
    q56: {
        text: "هل أنتِ صاحبة قامة صغيرة؟",
        question_type: "radio-arabic",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q14_a",
                text: "نعم",
                value: "Yes",
            },
            {
                id: "q14_b",
                text: "لا",
                value: "No",
            },
        ],
        db_column: "preference_expecting",
    },
    q57: {
        text: "الجينز",
        question_type: "radioSize-arabic",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                ],
            },
            {
                title: "US",
                values: [
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                ],
            },
            {
                title: "EU",
                values: [
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                ],
            },
        ],
        db_column: "size_jeans",
    },
    q58: {
        text: "حمالة الصدر",
        question_type: "radioSize-arabic",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "28",
                    "30",
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                ],
            },
            {
                title: "US",
                values: [
                    "28",
                    "30",
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                ],
            },
            {
                title: "EU",
                values: [
                    "28",
                    "30",
                    "32",
                    "34",
                    "36",
                    "38",
                    "40",
                    "42",
                    "44",
                    "46",
                    "48",
                ],
            },
        ],
        db_column: "size_bra",
    },
    q59: {
        text: "حجم الكوب",
        question_type: "radioSize-arabic",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "AA",
                    "A",
                    "B",
                    "C",
                    "D",
                    "DD",
                    "E",
                    "F",
                    "FF",
                    "G",
                    "GG",
                    "H",
                    "HH",
                ],
            },
            {
                title: "US",
                values: [
                    "AA",
                    "A",
                    "B",
                    "C",
                    "D",
                    "DD",
                    "E",
                    "F",
                    "FF",
                    "G",
                    "GG",
                    "H",
                    "HH",
                ],
            },
            {
                title: "EU",
                values: [
                    "AA",
                    "A",
                    "B",
                    "C",
                    "D",
                    "DD",
                    "E",
                    "F",
                    "FF",
                    "G",
                    "GG",
                    "H",
                    "HH",
                ],
            },
        ],
        db_column: "size_cup",
    },
    q60: {
        text: "الأحذية",
        question_type: "radioSize-arabic",
        gridStyle: GridColsEight,
        sizeStandardKey: SizeSelectionScreen,
        options: [
            {
                title: "UK",
                values: [
                    "3",
                    "3.5",
                    "4",
                    "4.5",
                    "5",
                    "5.5",
                    "6",
                    "6.5",
                    "7",
                    "7.5",
                    "8",
                ],
            },
            {
                title: "US",
                values: [
                    "5",
                    "5.5",
                    "6",
                    "6.5",
                    "7",
                    "7.5",
                    "8",
                    "8.5",
                    "9",
                    "9.5",
                    "10",
                ],
            },
            {
                title: "EU",
                values: [
                    "35.5",
                    "36",
                    "37",
                    "37.5",
                    "38",
                    "39",
                    "39.5",
                    "40",
                    "40.5",
                    "41",
                    "42",
                ],
            },
        ],
        db_column: "size_shoes",
    },
    q61: {
        text: "الستايلات التي أعجبتكِ",
        question_type: "swipe-arabic",
        options: [
            {
                id: "style_swipe_image_0",
                image: {
                    desktop:
                        "https://res.cloudinary.com/wearthat/image/upload/v1720466114/customers/do7ayopshskw1dv3ciyq.svg",
                    mobile: "https://res.cloudinary.com/wearthat/image/upload/v1720466262/customers/c1gxvgh1biohh4vqntul.svg",
                },
            },
            {
                id: "style_swipe_image_1",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621288/froy6qwhd8clmkazd3xb.svg",
            },
            {
                id: "style_swipe_image_2",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621189/wodlox0mptkl3hg0arwc.svg",
            },
            {
                id: "style_swipe_image_3",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621024/loeynokwvwoeqmfqmhcx.svg",
            },
            {
                id: "style_swipe_image_4",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621439/otaqd3h5d3w4cmpiv9ey.svg",
            },
            {
                id: "style_swipe_image_5",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622523/aspyun4hbsooyglsosfx.svg",
            },
            {
                id: "style_swipe_image_6",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622381/asjbek1ad85sdtonwbyo.svg",
            },
            {
                id: "style_swipe_image_7",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683620211/oyo63lquad3htnjoalf3.svg",
            },
            {
                id: "style_swipe_image_8",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622267/upv001vxnlmr00icvc4q.svg",
            },
            {
                id: "style_swipe_image_9",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622418/p79dz9tybipnswmefzgb.svg",
            },
            {
                id: "style_swipe_image_10",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621124/kxxg0s9q166vk3hx1k7r.svg",
            },
            {
                id: "style_swipe_image_11",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621063/fdqomjmjadpy28loqhaj.svg",
            },
            {
                id: "style_swipe_image_12",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621780/jwe7l6hp5rglgukvngna.svg",
            },
            {
                id: "style_swipe_image_13",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622454/pd7bngebh2xazhbk7fcl.svg",
            },
            {
                id: "style_swipe_image_14",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621523/ma7liuauvzaixbpuucrg.svg",
            },
            {
                id: "style_swipe_image_15",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621094/c8wov5im4veugmrpbtts.svg",
            },
            {
                id: "style_swipe_image_16",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621817/hkznj1eynfgfbeycp70v.svg",
            },
            {
                id: "style_swipe_image_17",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621666/bthsavmfqvsbirqlfngk.svg",
            },
            {
                id: "style_swipe_image_18",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621485/gyiw8wzyz3i6gngfvadd.svg",
            },
            {
                id: "style_swipe_image_19",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683621739/qj1ylnmde7eebotud04b.svg",
            },
            {
                id: "style_swipe_image_20",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622198/x8hzzosj8rsgulas4kxv.svg",
            },
            {
                id: "style_swipe_image_21",
                image: "http://res.cloudinary.com/wearthat/image/upload/w_337,h_620/v1683622305/moghf9yv0ldpxxlwiweu.svg",
            },
        ],
        db_column: "style_swipe",
    },
    q62: {
        text: "الجنسية*",
        question_type: "select",
        options: [
            "Afghan",
            "Albanian",
            "Algerian",
            "American",
            "Andorran",
            "Angolan",
            "Antiguan",
            "Argentine",
            "Armenian",
            "Australian",
            "Austrian",
            "Azerbaijani",
            "Bahamian",
            "Bahraini",
            "Bangladeshi",
            "Barbadian",
            "Belarusian",
            "Belgian",
            "Belizean",
            "Beninese",
            "Bhutanese",
            "Bolivian",
            "Bosnian",
            "Botswanan",
            "Brazilian",
            "British",
            "Bruneian",
            "Bulgarian",
            "Burkinabe",
            "Burmese",
            "Burundian",
            "Cambodian",
            "Cameroonian",
            "Canadian",
            "Cape Verdean",
            "Central African",
            "Chadian",
            "Chilean",
            "Chinese",
            "Colombian",
            "Comoran",
            "Congolese (Congo-Brazzaville)",
            "Congolese (Congo-Kinshasa)",
            "Costa Rican",
            "Croatian",
            "Cuban",
            "Cypriot",
            "Czech",
            "Danish",
            "Djiboutian",
            "Dominican",
            "Dominican (Dominican Republic)",
            "Dutch",
            "East Timorese",
            "Ecuadorian",
            "Egyptian",
            "Emirati",
            "Equatorial Guinean",
            "Eritrean",
            "Estonian",
            "Eswatini",
            "Ethiopian",
            "Fijian",
            "Filipino",
            "Finnish",
            "French",
            "Gabonese",
            "Gambian",
            "Georgian",
            "German",
            "Ghanaian",
            "Greek",
            "Grenadian",
            "Guatemalan",
            "Guinean",
            "Guinean (Guinea-Bissau)",
            "Guyanese",
            "Haitian",
            "Honduran",
            "Hungarian",
            "Icelandic",
            "Indian",
            "Indonesian",
            "Iranian",
            "Iraqi",
            "Irish",
            "Israeli",
            "Italian",
            "Ivorian",
            "Jamaican",
            "Japanese",
            "Jordanian",
            "Kazakh",
            "Kenyan",
            "Kiribati",
            "Korean (North)",
            "Korean (South)",
            "Kosovar",
            "Kuwaiti",
            "Kyrgyz",
            "Lao",
            "Latvian",
            "Lebanese",
            "Liberian",
            "Libyan",
            "Liechtensteiner",
            "Lithuanian",
            "Luxembourger",
            "Madagascan",
            "Malawian",
            "Malaysian",
            "Maldivian",
            "Malian",
            "Maltese",
            "Marshallese",
            "Mauritanian",
            "Mauritian",
            "Mexican",
            "Micronesian",
            "Moldovan",
            "Monacan",
            "Mongolian",
            "Montenegrin",
            "Moroccan",
            "Mozambican",
            "Namibian",
            "Nauruan",
            "Nepalese",
            "New Zealander",
            "Nicaraguan",
            "Nigerian",
            "Nigerien",
            "Niuean",
            "North Macedonian",
            "Norwegian",
            "Omani",
            "Pakistani",
            "Palauan",
            "Palestinian",
            "Panamanian",
            "Papua New Guinean",
            "Paraguayan",
            "Peruvian",
            "Polish",
            "Portuguese",
            "Qatari",
            "Romanian",
            "Russian",
            "Rwandan",
            "Saint Kitts and Nevis",
            "Saint Lucian",
            "Saint Vincentian",
            "Salvadoran",
            "Samoan",
            "San Marinese",
            "Sao Tomean",
            "Saudi Arabian",
            "Senegalese",
            "Serbian",
            "Seychellois",
            "Sierra Leonean",
            "Singaporean",
            "Slovak",
            "Slovenian",
            "Solomon Islander",
            "Somali",
            "South African",
            "South Sudanese",
            "Spanish",
            "Sri Lankan",
            "Sudanese",
            "Surinamese",
            "Swedish",
            "Swiss",
            "Syrian",
            "Tajik",
            "Tanzanian",
            "Thai",
            "Tongan",
            "Trinidadian/Tobagonian",
            "Tunisian",
            "Turkish",
            "Turkmen",
            "Tuvaluan",
            "Ugandan",
            "Ukrainian",
            "Uruguayan",
            "Uzbek",
            "Vanuatuan",
            "Venezuelan",
            "Vietnamese",
            "Yemeni",
            "Zambian",
            "Zimbabwean",
        ],
        db_column: "nationality",
    },
    q63: {
        text: "ما هو مجال عملكِ؟",
        question_type: "select-arabic",
        options: [
            { label: "الإنتاج / التصنيع", value: "Production / Manufacturing" },
            {
                label: "العناية الشخصية والخدمات",
                value: "Personal Care & Service",
            },
            { label: "المكاتب / الإدارة", value: "Office / Administration" },
            {
                label: "الخدمة العسكرية / الحماية",
                value: "Military / Protective Service",
            },
            { label: "الإعلام / الاتصالات", value: "Media / Communications" },
            { label: "الإدارة", value: "Management" },
            {
                label: "الضيافة / خدمات الطعام",
                value: "Hospitality / Food Service",
            },
            {
                label: "الممارس الصحي / الفني",
                value: "Health Practitioner / Technician",
            },
            { label: "الخدمات المالية", value: "Financial Services" },
            {
                label: "الزراعة / الصيد / الغابات",
                value: "Farming / Fishing / Forestry",
            },
            { label: "الفنان / المؤدي", value: "Entertainer / Performer" },
            { label: "الحاسوب / تقنية المعلومات", value: "Computer / IT" },
            {
                label: "الخدمة الاجتماعية / المجتمعية",
                value: "Community / Social Service",
            },
            {
                label: "الأعمال / خدمة العملاء",
                value: "Business / Client Service",
            },
            { label: "البناء / الصيانة", value: "Building / Maintenance" },
            { label: "الفن / التصميم", value: "Art / Design" },
            {
                label: "الهندسة المعمارية / الهندسة",
                value: "Architecture / Engineering",
            },
            { label: "التعليم", value: "Education" },
            { label: "القانون", value: "Legal" },
            { label: "طالب", value: "Student" },
            { label: "ربة منزل", value: "Stay-At-Home Parent" },
            { label: "العمل الحر", value: "Self-Employed" },
            { label: "النقل", value: "Transportation" },
            { label: "التكنولوجيا", value: "Technology" },
            { label: "العلوم", value: "Science" },
            { label: "المبيعات", value: "Sales" },
            { label: "التجزئة", value: "Retail" },
            { label: "متقاعد", value: "Retired" },
            { label: "غير موظف", value: "Not Employed" },
            { label: "أخرى", value: "Other" },
        ],
        // options: [
        //     "الإنتاج / التصنيع",
        //     "العناية الشخصية والخدمات",
        //     "المكاتب / الإدارة",
        //     "الخدمة العسكرية / الحماية",
        //     "الإعلام / الاتصالات",
        //     "الإدارة",
        //     "الضيافة / خدمات الطعام",
        //     "الممارس الصحي / الفني",
        //     "الخدمات المالية",
        //     "الزراعة / الصيد / الغابات",
        //     "الفنان / المؤدي",
        //     "الحاسوب / تقنية المعلومات",
        //     "الخدمة الاجتماعية / المجتمعية",
        //     "الأعمال / خدمة العملاء",
        //     "البناء / الصيانة",
        //     "الفن / التصميم",
        //     "الهندسة المعمارية / الهندسة",
        //     "التعليم",
        //     "القانون",
        //     "طالب",
        //     "ربة منزل",
        //     "العمل الحر",
        //     "النقل",
        //     "التكنولوجيا",
        //     "العلوم",
        //     "المبيعات",
        //     "التجزئة",
        //     "متقاعد",
        //     "غير موظف",
        //     "أخرى",
        // ],
        db_column: "occupation",
    },
    q64: {
        text: "ما هي المناسبة/المناسبات التي نركّز عليها في صندوقك الأول؟",
        selectionInfo: "(اختر اثنتين)",
        question_type: "checkbox-arabic",
        gridStyle: GridColsTwo,
        maxLimit: 2,
        options: [
            {
                id: "q1_a",
                text: "عطلة / مناسبة",
                next_question: null,
                value: "Holiday / Event",
            },
            {
                id: "q1_b",
                text: "الخروج",
                next_question: null,
                value: "Going Out",
            },
            {
                id: "q1_c",
                text: "العمل",
                next_question: null,
                value: "Work",
            },

            {
                id: "q1_d",
                text: "أساسيات خزانة الملابس",
                next_question: null,
                value: "Wardrobe Essentials",
            },
            {
                id: "q1_e",
                text: "الاستخدام اليومي",
                next_question: null,
                value: "Day to Day",
            },
        ],
        db_column: "firstbox_occasions_focus",
    },
    q65: {
        text: "هل تفضلين ارتداء ملابس محتشمة؟",
        question_type: "radio-arabic",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q45_a",
                text: "نعم",
                value: "Yes",
            },
            {
                id: "q45_b",
                text: "لا",
                value: "No",
            },
        ],
        db_column: "preference_modestly",
    },
    q66: {
        text: "هل ترتدين الحجاب؟",
        question_type: "animated_radio-arabic",
        depend_question: "q65",
        depend_answer: "Yes",
        gridStyle: GridColsTwo,
        options: [
            {
                id: "q46_a",
                text: "نعم",
                value: "Yes",
            },
            {
                id: "q46_b",
                text: "لا",
                value: "No",
            },
        ],
        db_column: "preference_hijabi",
    },
    q67: {
        text: null,
        question_type: "radio-arabic",
        gridStyle: GridColsOne,
        options: [
            {
                id: "q47_a",
                text: "من ١٬٠٠٠ إلى ٣٬٠٠٠ د.إ حتى ٤ إطلالات",
                value: "1-3k AED Up to 4 looks",
            },
            {
                id: "q47_b",
                text: "من ٣٬٠٠٠ إلى ٥٬٠٠٠ د.إ من ٥ إلى ٨ إطلالات",
                value: "3-5k AED 5-8 looks",
            },
            {
                id: "q47_c",
                text: "٥٬٠٠٠ د.إ وما فوق أكثر من ٨ إطلالات",
                value: "5k+ AED 8+ looks",
            },
        ],

        db_column: "box_budget_outfit",
    },
    q68: {
        text: "تاريخ الميلاد",
        question_type: "datePicker",
        label: "",
        options: [],
        db_column: "dob",
    },
};
